/**
 * @changelog
 *
 * 2026-03-11 (0.1.0) (jhoward)
 *   - Add App\Helpers\getAccountOffer() to retrieve a specific offer by domain and code.
 *   - Uses App\Helpers\getAccountOffers() for offer lookup.
 */

import type { OpcOffer } from '@/defs/api/OpcOffer';
import getAccountOffers from '@/helpers/getAccountOffers';

export default async function getAccountOffer(
  offerDomain: string,
  offerCode: string | number,
): Promise<OpcOffer | null> {
  const offers = await getAccountOffers(false);
  for (let i = 0; i < offers.length; i++) {
    if (
      offers[i].CASINO_OFFER_DOMAIN === offerDomain &&
      offers[i].CASINO_OFFER_CODE.toString() === offerCode.toString()
    ) {
      return offers[i];
    }
  }
  return null;
}
